var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotMarkerLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49839 9.69013C3.21255 9.35533 2 8.13643 2 6.50596C2 3.4326 4.34489 2 6.996 2C9.64712 2 11.992 4.29533 11.992 7.12649C11.992 7.12649 12.4209 11.4552 6.996 18L4.09112 14.3401",
    stroke: "#21323D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7,
    cy: 22,
    rx: 5,
    ry: 2,
    fill: "#21323D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotMarkerLight);
export default __webpack_public_path__ + "static/media/spot-marker-light.c01e02a0843c1643c4de8dbcbdb826c7.svg";
export { ForwardRef as ReactComponent };